<template>
  <div id="app">
    <router-view />
    <div id="qrcode" class="qrcode"></div>
  </div>
</template>

<script>
var constantJson = require('../static/constant.json')
import * as constant from '@/assets/js/constant.js'
import { mapMutations } from 'vuex'
export default {
  name: 'App',
  data() {
    return {}
  },
  mounted() {},
  created() {
    let username = this.$cookie.getCookie('username')
    let token = this.$cookie.getCookie('token')
    if (username && token) {
      // this.updateTokenReq()
      this.updateUser()
    }
    this.init()
    this.getThemeInfo()
  },

  beforeDestroy() {
    localStorage.clear()
    sessionStorage.clear()
    sessionStorage.setItem('workmodetype', '应用已销毁')
  },
  methods: {
    ...mapMutations('system', ['init', 'updateToken', 'updateUserInfo']),
    getThemeInfo() {
      //解析域名
      let data = {
        collegeUrl: 'usth-edu.hebooming.com',
      }
      this.$API['getThemeInfo'](data).then(
        (res) => {
          console.log('解析域名获取信息:', res)
          if (res.content.loginPage.length > 0 && res.content.frontPage.length > 0) {
            res.content.frontPage.forEach((ele) => {
              if (ele.contentCode === 'browser_sheet_name') {
                document.title = ele.content
              }
            })
            //存首页样式
            localStorage.setItem('loginPage', JSON.stringify(res.content.loginPage))
            localStorage.setItem('frontPage', JSON.stringify(res.content.frontPage))
            localStorage.setItem('belongCompanyId', res.theme.belongCompanyId)
          }
        },
        (err) => {
          //可配置通用登陆样式
          // that.hasDoLogin = false
        }
      )
    },
    // 更新token
    updateTokenReq() {
      let data = {}
      this.$API.updateToken(data).then(
        (res) => {
          if (res.jwt) {
            this.$cookie.setCookie('token', res.jwt)
            this.updateToken(res.jwt)
          }
        },
        (err) => {
          console.log('获取学校校区树err', err)
        }
      )
    },
    updateUser() {
      let data = {}
      this.$API.getUserInfo(data).then(
        (res) => {
          // console.log('获取用户信息', res)
          this.updateUserInfo(res)
          localStorage.setItem('campusId', res.campusId)
          localStorage.setItem('name', res.name)
          localStorage.setItem('phone', res.phone)
        },
        (err) => {
          console.log('getOrgTreeerr', err)
        }
      )
    },
  },
}
</script>

<style>
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.has-gutter {
  width: 100%;
}

.el-table__empty-block .el-tree-node__content:hover {
  background-color: #66b1ff87;
}

.dialog-select {
  width: 100%;
}

@keyframes play {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.1;
  }
  100% {
    opacity: 1;
  }
}
.playAnimation {
  animation: play 2s linear;
  animation-iteration-count: infinite;
}
@keyframes play2 {
  0% {
    box-shadow: 0rem 0rem 1.875rem #00ffed;
  }
  50% {
    box-shadow: 0rem 0rem 0rem #00ffed;
  }
  100% {
    box-shadow: 0rem 0rem 1.875rem #00ffed;
  }
}
.play2Animation {
  animation: play2 2s linear;
  animation-iteration-count: infinite;
}
@keyframes play3 {
  0% {
    box-shadow: 0rem 0rem 1.875rem #00ffed, inset 0rem 0rem 1.25rem #00ffed;
  }
  50% {
    box-shadow: 0rem 0rem 1.5625rem #00ffed, inset 0rem 0rem 0.9375rem #00ffed;
  }
  100% {
    box-shadow: 0rem 0rem 1.875rem #00ffed, inset 0rem 0rem 1.25rem #00ffed;
  }
}
.play3Animation {
  animation: play3 2s linear;
  animation-iteration-count: infinite;
}
</style>



// WEBPACK FOOTER //
// src/App.vue